import { ReactPlugin } from "@microsoft/applicationinsights-react-js"
import { ApplicationInsights } from "@microsoft/applicationinsights-web"
import { createBrowserHistory } from "history"
import { config } from "./config"

const browserHistory = createBrowserHistory({ basename: "" })
const reactPlugin = new ReactPlugin()
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: config.instrumentationKey,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    }
  }
})
appInsights.loadAppInsights()
export { reactPlugin, appInsights }
